<template>
    <div class="bg-grey-lighten-4 d-flex flex-row flex-wrap container-details-resultats">


        <div class=" pa-3 d-flex flex-md-row details-card-resultats"
            v-for="(resultat, index_resultat) in item.resultats" :key="index_resultat">

            <v-card class=" pa-0">

                <div class="bg-primary pa-2">
                    <div class="text-h6">{{ resultat.nom_epreuve }}</div>
                    <div>{{ format_date(resultat.date_epreuve) }} - {{ resultat.course }}</div>
                </div>
                <div class="px-2 py-3">
                    <div class="mb-3">Clt Scratch {{ get_sexe(resultat) }} <b>{{ resultat.classement_par_sexe }}</b>
                        <span class="text-secondary"><b>|</b></span> Clt Cat.
                        <b>{{
                            resultat.classement_par_cat }}</b>
                    </div>
                    <div class="d-flex flex-row flex-wrap">
                        <v-chip variant="elevated" elevation="0" size="small" label color="secondary"
                            class="font-weight-bold ma-1">{{
                                resultat.points_scratch
                            }}pts
                            Scratch</v-chip>
                        <v-chip variant="elevated" elevation="0" size="small" label color="secondary"
                            class="font-weight-bold ma-1">{{ resultat.points_cat }}pts Cat</v-chip>
                    </div>
                </div>


            </v-card>
        </div>
    </div>






</template>

<script>
import moment from 'moment';
export default {
    props: ["item"],
    name: 'DetailsResultats',
    data() {
        return {
            // Your component's data goes here
        };
    },
    methods: {
        get_sexe() {
            if (this.item.sexe == 'M') {
                return 'Homme';
            } else {
                return 'Femme';
            }
        },
        format_date(date) {

            return moment(date).format('DD/MM/YYYY');
        },
        // Your component's methods go here
    },
    computed: {
        // Your computed properties go here
    },
    mounted() {
        // Code to run when the component is mounted goes here
    },
};
</script>

<style scoped>
.details-card-resultats {
    max-width: min(300px, 100%);
}

.container-details-resultats {
    max-width: 100vw;
}

/* Your component's CSS styles go here */
</style>